<template>
    <b-container fluid>
        <b-form-row>
            <b-col lg="12" md="6" sm="12">
                <h6 v-if="response.requirement_text != 'Not yet reviewed'">Requirement {{response.index + 1}}</h6>
                <b-form-textarea
                :readonly="true"
                v-if="response.requirement_text == 'Not yet reviewed'"
                placeholder="Requirements are still being loaded for this opportunity. Reach out to your Brighton Cromwell POC with any questions."
                >
                </b-form-textarea>
                <b-form-textarea
                v-model="response.requirement_text"
                :readonly="true"
                v-else
                >
                </b-form-textarea>
            </b-col>
        </b-form-row>
    </b-container>

</template>

<script>
export default {
    name: 'rfq-requirement-form',
    props: [
    'response',
    'id',
    'requirement_index',
  ],
  }
</script>